<script setup>
import { ref } from 'vue'
import { Icon } from '@iconify/vue2'
import { useDropZone } from '@vueuse/core'

const emit = defineEmits(['onInput'])

const dropZoneRef = ref()
const uploading = ref(false)
const progress = ref(0)

const initProgress = () => {
	progress.value += 10
	if (progress.value >= 100) {
		uploading.value = false
		_interval.value = clearInterval(_interval.value)
	}
}

const _interval = ref()

function onDrop(files) {
	progress.value = 0
	emit('onInput', files)
	console.log('🚀 ~ file: NewFileUpload.vue:13 ~ onDrop ~ files:', files)
	uploading.value = true

	//TODO fazer com que tempo de upload seja dinamico, respeitando promisses, etc...
	_interval.value = setInterval(initProgress, props.interval)
}

const { isOverDropZone } = useDropZone(dropZoneRef, onDrop)

const props = defineProps({
	accept: {
		type: String,
		default: '*/*',
	},
	multiple: {
		type: Boolean,
		default: false,
	},
	maxFileSize: {
		type: Number,
		default: 5,
	},
	maxFiles: {
		type: Number,
		default: 1,
	},
	files: {
		type: [FileList, Array],
	},
	interval: {
		type: Number,
		default: 50,
	},
})
</script>

<template>
	<div
		ref="dropZoneRef"
		:class="isOverDropZone || uploading || progress >= 100 ? 'border-solid' : 'border-dashed'"
		class="border border-[#737576] text-[#272728] flex items-center flex-col rounded-lg py-4"
	>
		<div
			v-if="!files?.length"
			class="flex flex-col items-center"
		>
			<Icon
				icon="heroicons-outline:paper-clip"
				class="text-2xl mb-4"
			/>
			<span>
				<label
					class="text-[#6745ED] cursor-pointer"
					for="input"
					>{{ $t('selecione') }}</label
				>
				{{ $t('arrasteOArquivo') }}
			</span>
			<span v-if="accept != '*/*'">(Formato suportado {{ accept }} )</span>
			<input
				id="input"
				type="file"
				name=""
				class="hidden"
				@input="onDrop($event.target.files)"
			/>
		</div>
		<div
			v-else
			class="w-full w-full px-6 flex flex-col py-4"
		>
			<div class="flex justify-between items-center">
				<p class="!m-0 text-base font-bold text-[#272728]">
					{{ files[0].name }}
				</p>
				<Icon
					v-if="progress >= 100"
					icon="iconamoon:check-bold"
					class="text-xl"
					color="#138600"
				/>
				<Icon
					v-else
					icon="octicon:x-12"
					class="text-xl hover:text-[#C60020] cursor-pointer"
					@click="emit('onInput', [])"
				/>
			</div>
			<p class="!m-0 text-[#737576]">
				{{ progress >= 100 ? 'Upload concluído' : 'Fazendo upload...' }}
			</p>
			<div class="w-full h-[8px]">
				<div class="w-full h-full bg-[#B9BABA] rounded-full">
					<div :class="`w-[${progress}%] h-full bg-[#34617E] rounded-full`" />
				</div>
			</div>
		</div>
	</div>
</template>
